import React, { useState, useEffect, useRef } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from '../LanguageContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const LANGUAGES = [
  { code: 'en', country: 'GB', name: 'English' },
  { code: 'cs', country: 'CZ', name: 'Čeština' },
  { code: 'da', country: 'DK', name: 'Dansk' },
  { code: 'de', country: 'DE', name: 'Deutsch' },
  { code: 'es', country: 'ES', name: 'Español' },
  { code: 'et', country: 'EE', name: 'Eesti' },
  { code: 'fi', country: 'FI', name: 'Suomi' },
  { code: 'fr', country: 'FR', name: 'Français' },
  { code: 'hu', country: 'HU', name: 'Magyar' },
  { code: 'it', country: 'IT', name: 'Italiano' },
  { code: 'lt', country: 'LT', name: 'Lietuvių' },
  { code: 'lv', country: 'LV', name: 'Latviešu' },
  { code: 'nl', country: 'NL', name: 'Nederlands' },
  { code: 'no', country: 'NO', name: 'Norsk' },
  { code: 'pl', country: 'PL', name: 'Polski' },
  { code: 'pt', country: 'PT', name: 'Português' },
  { code: 'ro', country: 'RO', name: 'Română' },
  { code: 'ru', country: 'RU', name: 'Русский' },
  { code: 'sk', country: 'SK', name: 'Slovenčina' },
  { code: 'sv', country: 'SE', name: 'Svenska' },
  { code: 'el', country: 'GR', name: 'Ελληνικά' },
  { code: 'tl', country: 'PH', name: 'Filipino' },
].sort((a, b) => a.name.localeCompare(b.name));

function LanguageSelector({ inline = false }) {
  const [open, setOpen] = useState(false);
  const { lang: current, changeLang } = useTranslation();
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const select = async (code) => {
    changeLang(code);
    setOpen(false);

    const token = localStorage.getItem('token');
    if (token) {
      try {
        await fetch(API_URL + '/api/auth/update-language', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ language: code })
        });
      } catch (e) {}
    }
  };

  const currentLang = LANGUAGES.find(l => l.code === current) || LANGUAGES.find(l => l.code === 'en');

  return (
    <div ref={ref} style={inline
      ? { position: 'relative' }
      : { position: 'fixed', top: '14px', right: '14px', zIndex: 1000 }
    }>

      {/* Nupp */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: 'rgba(255,255,255,0.95)',
          border: '1px solid #ddd',
          borderRadius: '20px',
          padding: '10px 14px',
          minHeight: '44px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        }}>
        <ReactCountryFlag countryCode={currentLang.country} svg style={{ width: '22px', height: '16px', display: 'block', borderRadius: '2px', flexShrink: 0 }} />
        <span style={{ color: '#333' }}>{currentLang.name}</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: 'absolute',
          top: '50px',
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          overflow: 'hidden',
          minWidth: '170px',
          maxHeight: '60vh',
          overflowY: 'auto',
        }}>
          {LANGUAGES.map(lang => (
            <div
              key={lang.code}
              onClick={() => select(lang.code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 14px',
                cursor: 'pointer',
                background: lang.code === current ? '#f9f0f4' : 'white',
                borderLeft: lang.code === current ? '3px solid #6b0f3a' : '3px solid transparent',
                fontSize: '14px',
                color: '#333',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#fdf0f5'}
              onMouseLeave={e => e.currentTarget.style.background = lang.code === current ? '#f9f0f4' : 'white'}
            >
              <ReactCountryFlag countryCode={lang.country} svg style={{ width: '22px', height: '16px', display: 'block', borderRadius: '2px', flexShrink: 0 }} />
              <span>{lang.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
